import React from "react";
import "../Styles/IntroBlock.css"
import Solly from "../Assets/solly.png"


const TopicStringBlock = () =>{

    return (
            <div className="intro-block-container">
                <div className="intro-text-image">
                    <div className="intro-text-block">
                        <h1>Topic Tester</h1>
                        <p>Do you struggle to picture a Topic hierarchy at work?</p>
                        <p>This demo will help you preview how your design choices — from root to events — will deliver multiple Topic options.</p>
                        <p><i>Welcome to the Topic Display Tool.</i> </p>
                        <p>To use it, choose from the pre-populated data in the “Demo” tab, or input your own data in the “Try it” tab.</p>     
                        <p>When you’re ready, click “Generate”!</p>
                    </div>

                    <div>
                        <img src={Solly} alt="Sollace mascot" className="solly"></img>
                    </div>
                </div>
            
            </div>
)
}

export default TopicStringBlock;